import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const RedesignReceivedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.REDESIGN_RECEIVED),
});
